var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 273.69 53.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #e1001a;\n      }\n\n      .cls-3 {\n        fill: #4b4b4d;\n      }\n\n      .cls-4 {\n        fill: #00001a;\n        isolation: isolate;\n        opacity: .58;\n      }\n\n      .cls-5 {\n        fill: url(#Unbenannter_Verlauf_11);\n      }\n\n      .cls-6 {\n        fill: url(#Unbenannter_Verlauf_2);\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_11",
    "data-name": "Unbenannter Verlauf 11",
    cx: 1536.88,
    cy: 3034.43,
    fx: 1536.88,
    fy: 3034.43,
    r: 3.23,
    gradientTransform: "translate(9596.09 -27017.03) rotate(45) scale(8.02 8.53)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffeae2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#f29572"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#e1001a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#ce001a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ae0819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b20414"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_2",
    "data-name": "Unbenannter Verlauf 2",
    x1: 880.29,
    y1: 5102.89,
    x2: 909.9,
    y2: 5122.91,
    gradientTransform: "translate(-878.62 5130.47) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#464648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#464648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#909193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#464648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#515153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#909193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#515153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515153"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "g6550"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5992"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5994",
    d: "M54.93,29.27h-4.62v-11.93h-8.27v7.03c0,2.73-2.2,4.93-4.9,4.93V7.33c0-2.66,2.13-4.83,4.86-4.83h.04V13.79h8.27V7.15c0-2.56,2.02-4.65,4.58-4.65h.04V29.27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5996"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5998",
    d: "M68.55,9.39h4.47l-8.13,24.93c-.53,1.63-2.1,2.84-4.15,2.84h-1.52l3.12-8.98-6.21-18.78h5.04l3.59,13.14,3.8-13.14"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6000"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6002",
    d: "M84.99,19.4c0-4.76-1.35-7-4.44-7-.78,0-1.39,.11-1.99,.32v13.53c.46,.18,1,.25,1.67,.25,3.94,0,4.76-3.91,4.76-7.1Zm4.72-.14c0,6.18-3.37,10.3-8.52,10.3-1.03,0-1.95-.14-2.63-.32v3.44c0,2.45-1.99,4.48-4.44,4.48h-.25V10.84l.11-.07c1.74-.92,3.98-1.38,6.67-1.38,5.65,0,9.05,3.73,9.05,9.87"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6004"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6006",
    d: "M103.66,19.43c0-2.02-.5-6.89-4.22-6.89s-4.15,5.33-4.15,6.89,.32,6.75,4.15,6.75,4.22-5.18,4.22-6.75Zm4.4,.04c0,6.14-3.3,10.08-8.63,10.08s-8.63-3.94-8.63-10.08,3.23-10.08,8.63-10.08,8.63,3.87,8.63,10.08"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6008"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6010",
    d: "M126.8,2.5l-7.35,23.65c-.57,1.81-2.34,3.12-4.37,3.12h-1.28L105.36,2.5h5.04l5.89,20.74,5.01-17.58c.53-1.88,2.45-3.16,4.54-3.16h.96"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6012"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6014",
    d: "M136.83,16.84c-.14-3.94-2.59-4.37-3.91-4.37h-.18c-2.66,.07-3.9,1.95-3.9,5.47l7.99-1.1Zm4.12,2.7l-11.82,1.63c.39,3.23,2.02,4.93,5.01,4.93,3.3,0,4.97-1.07,6.18-1.92v3.94c-1.21,.64-3.44,1.42-6.64,1.42-5.79,0-9.23-3.9-9.23-10.15s3.2-10.01,8.45-10.01,8.06,3.45,8.06,9.41v.75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6016"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6018",
    d: "M149.38,9.39c.78,0,1.77,.07,2.66,.21v3.8c-1.63-1.17-3.8-.78-4.76-.28v11.68c0,2.45-2.02,4.48-4.47,4.48h-.25V10.91c1.85-.89,3.73-1.53,6.82-1.53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6020"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6022",
    d: "M163.74,16.84c-.14-3.94-2.59-4.37-3.9-4.37h-.18c-2.66,.07-3.91,1.95-3.91,5.47l7.99-1.1Zm4.12,2.7l-11.82,1.63c.39,3.23,2.02,4.93,5.01,4.93,3.3,0,4.97-1.07,6.18-1.92v3.94c-1.21,.64-3.44,1.42-6.64,1.42-5.79,0-9.23-3.9-9.23-10.15s3.2-10.01,8.45-10.01,8.06,3.45,8.06,9.41v.75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6024"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6026",
    d: "M173.83,9.39V29.27h-.21c-2.49,0-4.48-2.02-4.48-4.48V9.39h4.69Zm.25-4.51c0,1.28-1.17,2.31-2.59,2.31s-2.56-1.03-2.56-2.31,1.14-2.38,2.56-2.38,2.59,1.07,2.59,2.38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6028"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6030",
    d: "M183.54,9.39c6.64,0,7.7,3.73,7.7,5.97v13.92h-.21c-2.45,0-4.54-2.06-4.54-4.51V15.42c0-1.31-.53-2.88-3.12-2.88-1.21,0-1.92,.14-2.7,.43V29.27h-4.76V10.84c2.02-.89,5.29-1.46,7.63-1.46"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6032"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6034",
    d: "M204.8,23.62c0,3.12-2.73,5.93-6.92,5.93-2.24,0-4.16-.64-5.29-1.38v-3.98c1.35,1.6,3.16,2.09,4.72,2.09,1.77,0,2.95-1.03,2.95-2.59s-.85-2.38-2.81-3.16c-3.62-1.38-4.47-3.51-4.47-5.5,0-3.05,2.52-5.65,6.18-5.65,2.17,0,3.34,.57,4.58,1.35v3.59c-1.24-1.49-2.34-1.92-3.69-1.92-1.78,0-2.77,1.07-2.77,2.41,0,1.56,1.17,2.38,2.87,3.05,3.69,1.53,4.65,3.52,4.65,5.75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6036"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6038",
    d: "M210.93,26.54c.46,.11,1.56,.18,2.24,.18,3.23,0,4.83-2.45,4.83-6.85,0-4.05-1.35-7.24-5.15-7.24-.68,0-1.31,.14-1.92,.32v13.6Zm0-24.04V10.59c.85-.25,1.85-.43,2.91-.43,5.01,0,8.45,3.66,8.45,9.98s-3.2,9.41-8.8,9.41h-.82c-1.49,0-5.04-.25-6.42-.53V7.01c0-2.49,1.99-4.51,4.47-4.51h.21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6040"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6042",
    d: "M233.91,18.94c-4.15,.39-6.67,1.24-6.67,4.55,0,2.45,1.49,3.55,4.05,3.55,1,0,2.17-.07,2.63-.18v-7.92Zm0-2.2v-1.31c0-2.52-1.56-3.2-3.83-3.2-1.88,0-3.76,.71-5.86,1.81v-3.16c1.24-.6,3.59-1.49,6.64-1.49,4.01,0,7.35,2.02,7.35,7v12.64c-1.31,.25-4.37,.53-6.21,.53h-.99c-5.25,0-7.99-2.2-7.99-5.93,0-5.11,4.97-6.32,10.9-6.89"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6044"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6046",
    d: "M247.85,9.39c6.64,0,7.71,3.73,7.71,5.97v13.92h-.21c-2.45,0-4.54-2.06-4.54-4.51V15.42c0-1.31-.53-2.88-3.13-2.88-1.21,0-1.92,.14-2.7,.43V29.27h-4.76V10.84c2.02-.89,5.29-1.46,7.63-1.46"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6048"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6050",
    d: "M262.33,24.65c0,2.56-1.99,4.62-4.65,4.62h-.04V7.11c0-2.56,1.99-4.62,4.65-4.62h.04V18.62l5.9-8.73h4.44l-6.07,8.88,7.1,10.51h-4.97l-6.39-9.84v5.22"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g6582"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6052"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6054",
    className: "cls-2",
    d: "M40.57,50.67c-2.1,0-3.44-1.38-3.44-3.16v-7.52h1.48v7.5c0,1.33,.95,2.08,2.04,2.08s2.02-.75,2.02-2.08v-7.5h1.35v7.52c0,1.79-1.33,3.16-3.45,3.16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6056"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6058",
    className: "cls-2",
    d: "M50.23,50.5v-5.91c0-.76-.34-1.6-1.81-1.6-.8,0-1.19,.11-1.64,.29v7.23h-1.41v-7.81c.77-.35,1.78-.58,3.16-.58,2.41,0,3.12,1.27,3.12,2.45v5.94h-1.41"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path6060",
    className: "cls-2",
    d: "M54.39,50.5h-1.41v-8.24h1.41v8.24Zm-.71-9.83c-.47,0-.84-.34-.84-.73s.37-.75,.84-.75,.82,.33,.82,.75-.37,.73-.82,.73"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g6062"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6064",
    className: "cls-2",
    d: "M59.58,50.66c-2.65,0-4.14-2.43-4.14-5.41s1.48-5.41,4.14-5.41c.98,0,1.67,.25,2.15,.58l-.35,.83c-.34-.2-.85-.41-1.54-.41-2.12,0-2.86,2.19-2.86,4.42s.82,4.36,2.84,4.36c.68,0,1.12-.17,1.54-.41l.39,.89c-.48,.35-1.27,.58-2.17,.58"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6066"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6068",
    className: "cls-2",
    d: "M65.73,43.15c-.71-.2-1.51-.14-1.98,.16v7.2h-1.41v-7.79c.85-.41,1.67-.63,3.73-.58l-.34,1.02"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6070"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6072",
    className: "cls-2",
    d: "M69.36,42.99c-1.25,0-2.19,.96-2.15,3.19l4.14-.6c0-1.86-.76-2.6-1.99-2.6Zm-2.1,3.91c.16,1.86,1.08,2.78,2.63,2.78,.98,0,1.69-.23,2.14-.47l.37,.89c-.53,.31-1.45,.56-2.62,.56-2.26,0-3.85-1.36-3.85-4.29s1.45-4.25,3.49-4.25,3.33,1.28,3.29,4.03l-5.45,.75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6074"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6076",
    className: "cls-2",
    d: "M78.39,43.12c-.35-.09-.71-.15-1.07-.15-2.01,0-2.65,1.65-2.65,3.44,0,1.94,.71,3.36,2.47,3.36,.58,0,.98-.06,1.25-.23v-6.42Zm-1.32,7.53c-2.47,0-3.81-1.65-3.81-4.14,0-2.74,1.53-4.32,3.76-4.32,.48,0,.9,.06,1.36,.18v-3.87h1.4v11.57c-.58,.34-1.51,.58-2.72,.58"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path6078",
    className: "cls-2",
    d: "M82.53,50.5h-1.41v-8.24h1.41v8.24Zm-.71-9.83c-.47,0-.83-.34-.83-.73s.37-.75,.83-.75,.82,.33,.82,.75-.37,.73-.82,.73"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g6080"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6082",
    className: "cls-2",
    d: "M86.48,50.58c-1.57,0-2.15-1.07-2.15-2.08v-5.39h-1v-.84h1v-1.89l1.41-.41v2.31h1.51v.84h-1.51v5.36c0,.66,.3,1.19,1.09,1.19,.14,0,.27-.03,.42-.06v.86c-.16,.04-.42,.12-.77,.12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6084"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6086",
    className: "cls-2",
    d: "M95.72,50.66c-2.57,0-4.64-1.77-4.64-5.49,0-3.5,2.12-5.33,4.64-5.33,1.2,0,2.06,.23,2.59,.55l-.43,.87c-.37-.21-1.01-.43-1.99-.43-2.04,0-3.28,1.41-3.28,4.46,0,2.86,1.37,4.39,3.1,4.39,.76,0,1.16-.12,1.38-.25v-3.94h-1.88v-.89h3.31v5.47c-.67,.37-1.41,.58-2.8,.58"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6088"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6090",
    className: "cls-2",
    d: "M103.14,43.15c-.71-.2-1.51-.14-1.98,.16v7.2h-1.41v-7.79c.85-.41,1.67-.63,3.73-.58l-.34,1.02"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6092"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6094",
    className: "cls-2",
    d: "M106.73,42.97c-1.65,0-1.98,1.76-1.98,3.42s.35,3.33,1.98,3.33,1.96-1.68,1.96-3.33-.3-3.42-1.96-3.42Zm0,7.69c-2.36,0-3.39-1.85-3.39-4.26s1.04-4.28,3.37-4.28,3.39,1.82,3.39,4.28-1.03,4.26-3.37,4.26"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6096"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6098",
    className: "cls-2",
    d: "M114.07,50.67c-2.17,0-3.07-1.04-3.07-2.69v-5.72h1.41v5.76c0,.96,.55,1.69,1.74,1.69,.68,0,1.16-.11,1.56-.33v-7.12h1.41v7.75c-.64,.35-1.66,.66-3.05,.66"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6102",
    className: "cls-2",
    d: "M120.99,42.92c-.53,0-.9,.09-1.24,.23v6.47c.28,.11,.63,.18,1.06,.18,1.75,0,2.65-1.3,2.65-3.49s-.64-3.39-2.47-3.39Zm.11,7.7c-.5,0-1.03-.09-1.35-.2v3.36h-1.4v-11.1c.58-.32,1.46-.58,2.7-.58,2.44,0,3.82,1.62,3.82,4.14,0,2.74-1.49,4.37-3.78,4.37"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g9106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6719",
    className: "cls-4",
    d: "M16.56,1.3C7.99,1.3,1.05,8.25,1.05,16.82c0,4,1.51,7.64,3.99,10.39-.1,.14-.71,1-.73,1.03-.25,.35-.76,.93-.25,1.45,.5,.52,1.43-.23,1.76-.47,.04-.03,.57-.43,.74-.55,2.7,2.28,6.19,3.66,10,3.66,8.56,0,15.51-6.94,15.51-15.5,0-2.85-.77-5.52-2.11-7.81,.5-.52,.79-.95,.78-1.31-.02-.74,.42-1.65-2.79-1.99-.19-.02-.4-.04-.62-.05-2.79-2.69-6.59-4.35-10.77-4.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8100",
    className: "cls-5",
    d: "M31.02,15.51c0,8.56-6.94,15.5-15.5,15.5S0,24.07,0,15.51,6.94,0,15.51,0s15.5,6.94,15.5,15.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7433",
    className: "cls-3",
    d: "M14.19,7.3c.32,.25,1.95,1.2,2.43,1.5l.17,.12,.08-.12c.17-.28,.24-.51-.25-.82-.49-.3-2.11-1.25-2.43-1.5l-.53-.43c.2,.56,.34,1.1,.53,1.25"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g7639"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path7641",
    className: "cls-1",
    d: "M14.53,11.2s1.79-2.32,1.96-2.6c.17-.29,.24-.51-.25-.82-.49-.3-2.11-1.25-2.43-1.5-.32-.25-.27-1.16,.68-1.35,.95-.19,9.19-.87,12.41-.53,3.21,.34,2.92,1.5,2.79,1.99-.19,.72-1.29,1.81-3.04,3.38,0,0-2.89,2.68-5,4.52-2.11,1.84-8.85,7.52-10.16,8.55-1.31,1.03-6.39,4.81-6.72,5.05-.33,.25-1.25,.99-1.75,.47-.5-.52,0-1.09,.25-1.45,.25-.35,10.5-14.81,11.26-15.73"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path8622",
    className: "cls-6",
    d: "M29.5,5.28c.13,.32,.25,.92,.2,1.12-.19,.72-1.29,1.81-3.04,3.38,0,0-2.89,2.68-5,4.52-2.11,1.84-8.85,7.52-10.16,8.55-1.31,1.03-6.39,4.81-6.72,5.05-.25,.19-1.37,.35-1.86,.34,.16,.23,.44,.48,.74,.76,.52,.5,1.43-.23,1.76-.47,.33-.25,5.41-4.03,6.72-5.05,1.31-1.03,8.06-6.71,10.16-8.55,2.11-1.84,5-4.52,5-4.52,1.75-1.58,2.7-2.43,2.89-3.15,.09-.33,.2-1.37-.67-1.97"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.3d6389c800d322d5d1859ec18498730c.svg";
export { ForwardRef as ReactComponent };